import { WsReactBaseService } from '@thewhite/react-base-components';
import { BaseActions } from '@thewhite/react-global-module/lib/actions';
import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { api } from '../../../config/api';
import { globalConfig } from '../../../config/globalConfig';
import { PaginationListParams } from '../../Global/interfaces/PaginationListParams';
import { SimpleValue, SimpleValueDTO, SimpleValueType } from '../../Global/models/simpleValue';
import { SearchChatListParams } from '../interface/SearchChatListParams';
import { SearchChatPageParams } from '../interface/SearchChatPageParams';
import Chat, { ChatDto, ChatType } from '../model/chat';
import Message, { MessageDto, MessageType } from '../model/message';

export class ChatActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/chat-service/chat/`;
    static api         = api;

    /**
     * Получить чат
     * @param id
     */
    static get = (id: string): Promise<Chat | null> => {
        return ChatActions.MODEL_API_RESOURCE<ChatDto, Chat>({
            url: id,
            model: Chat,
            modelType: ChatType,
            withoutToast: true,
        });
    };

    /**
     * Получить список чатов
     * @param params
     */
    static list = (params: SearchChatListParams): Promise<Chat[]> => {
        return ChatActions.ARRAY_API_RESOURCE<ChatDto, Chat>({
            url: 'list',
            queryParams: params,
            model: Chat,
            modelType: ChatType,
        });
    };

    /**
     * Получить постраничный список чатов
     * @param params
     */
    static page = (params: SearchChatPageParams): Promise<CollectionDTOInterface<Chat>> => {
        return ChatActions.COLLECTION_API_RESOURCE<ChatDto, Chat>({
            url: 'page',
            queryParams: params,
            model: Chat,
            modelType: ChatType,
        });
    };

    /**
     * Закрепить чат за оператором
     * @param id
     */
    static assign = (id: string): Promise<null> => {
        return ChatActions.API_RESOURCE(
            `${id}/assign`,
            WsReactBaseService.POST_METHOD,
        );
    };

    /**
     * Открепить чат за оператором
     * @param id
     */
    static unassign = (id: string): Promise<null> => {
        return ChatActions.API_RESOURCE(
            `${id}/unassign`,
            WsReactBaseService.POST_METHOD,
        );
    };

    /**
     * Получить сообщения в чате
     * @param id
     * @param params
     */
    static getMessages = (id: string, params: PaginationListParams): Promise<CollectionDTOInterface<Message>> => {
        return ChatActions.COLLECTION_API_RESOURCE<MessageDto, Message>({
            url: `${id}/messages/list`,
            queryParams: params,
            model: Message,
            modelType: MessageType,
        });
    };

    /**
     * Прочитать все сообщения в чате
     * @param id
     */
    static readAll = (id: string): Promise<null> => {
        return ChatActions.API_RESOURCE(
            `${id}/messages/read-all`,
            WsReactBaseService.POST_METHOD,
        );
    };

    /**
     * Получить количество непрочитанных сообщений в чате
     * @param id
     */
    static getUnreadCount = (id: string): Promise<SimpleValue | null> => {
        return ChatActions.MODEL_API_RESOURCE<SimpleValueDTO, SimpleValue>({
            url: `${id}/messages/unread-count`,
            model: SimpleValue,
            modelType: SimpleValueType,
            withoutToast: true,
        });
    };
}
